/**
 * Shared severity helpers + category metadata for the per-car compliance alerts
 * (Insurance / Technical control / Tax / Service). Used by both the vendor card pill row
 * and the edit-car dialog form.
 */
import { Shield, Wrench, Receipt, Sparkles, Sparkle } from "lucide-react";

export const ALERT_CATEGORIES = [
  { key: "insurance",         dateField: "insurance_expires_at",         noteField: "insurance_note",         label: "Insurance",         icon: Shield },
  { key: "technical_control", dateField: "technical_control_expires_at", noteField: "technical_control_note", label: "Technical control", icon: Wrench },
  { key: "tax",               dateField: "tax_expires_at",               noteField: "tax_note",               label: "Tax",               icon: Receipt },
  { key: "service",           dateField: "next_service_due_at",          noteField: "service_note",           label: "Service",           icon: Sparkles },
];

// Mirrors backend thresholds in core.py
export const RED_DAYS = 7;
export const AMBER_DAYS = 30;

export const severityFor = (iso) => {
  if (!iso) return { severity: "none", daysUntil: null };
  const d = new Date(iso);
  if (isNaN(d.getTime())) return { severity: "none", daysUntil: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  const days = Math.round((d.getTime() - today.getTime()) / 86400000);
  if (days < 0) return { severity: "expired", daysUntil: days };
  if (days <= RED_DAYS) return { severity: "critical", daysUntil: days };
  if (days <= AMBER_DAYS) return { severity: "warning", daysUntil: days };
  return { severity: "ok", daysUntil: days };
};

export const SEVERITY_STYLES = {
  expired:  { bg: "bg-rose-100",    text: "text-rose-800",    border: "border-rose-300", dot: "bg-rose-500",    label: "Expired" },
  critical: { bg: "bg-orange-100",  text: "text-orange-800",  border: "border-orange-300", dot: "bg-orange-500", label: "Expires soon" },
  warning:  { bg: "bg-amber-100",   text: "text-amber-900",   border: "border-amber-300", dot: "bg-amber-500",   label: "Expires this month" },
  ok:       { bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500", label: "OK" },
  none:     { bg: "bg-neutral-50",  text: "text-neutral-500", border: "border-border",    dot: "bg-neutral-300",  label: "Not set" },
};
